import React, { useEffect, useState } from 'react'
import TextFieldUniversal from '../../../../validate/form/text/TextFieldUniversal'

const SupplierEdrpouField = ({ required, setValidate, setValueForm, forciblyValue }) => {

  	const [value, setValue] = useState('')

  return (
	<TextFieldUniversal
        value={value}
        setValue={e => {
            setValueForm(e)
            setValue(e)
        }}
        setValidate={setValidate}
        label={'ЄДРПОУ/ІПН постачальника'} 
        placeholder={'12345678'}
        validates={{
            isEmpty: true,
            isDigit: true,
        }}
        forciblyValue={forciblyValue}
        required={required}
    />
  )
}

export default SupplierEdrpouField